import L from "leaflet";
import { useEffect } from "react";

// Lets map layers open the shared info card without threading props; useInfoCard listens.
let listener = null;

export function setMapCardListener(fn) {
  listener = fn;
  return () => {
    if (listener === fn) listener = null;
  };
}

// card: { key, title, subtitle?, icon?, rows?: [label|null, value][], text?, footer?, anchor, onClose? }
export function openMapCard(card) {
  listener?.(card);
}

// Without a prefix closes any info card, with one only a card whose key starts with it.
export function closeMapCard(keyPrefix = null) {
  listener?.(null, keyPrefix);
}

// A layer closes its own open card when it is hidden or unmounted.
export function useCloseMapCardWhenHidden(keyPrefix, visible) {
  useEffect(() => {
    if (!visible) {
      closeMapCard(keyPrefix);
      return undefined;
    }
    return () => closeMapCard(keyPrefix);
  }, [keyPrefix, visible]);
}

// Click on a Leaflet layer opens the card at `anchor` (default: the click position).
export function bindMapCard(layer, buildCard, anchorOf = (e) => e.latlng) {
  layer.on("click", (e) => {
    L.DomEvent.stopPropagation(e);
    const card = buildCard(e);
    if (card) openMapCard({ ...card, anchor: anchorOf(e) });
  });
}
